export const getCookieByName = name => {
    return ('; ' + document.cookie).split('; ' + name + '=').pop().split(';').shift();
}